// Unresolved TS build error TS2304: Cannot find name 'window'.
// Tried to apply this as solution but didn't resolve https://stackoverflow.com/questions/41336301/typescript-cannot-find-name-window-or-document
// @ts-ignore
export const isBrowser = typeof window !== 'undefined';
